(function(){
  var RAW_TIERS = window.BYOB_TIERS || [];
  var STORIES = window.BYOB_STORIES || [{ label: "All", products: [] }];

  // Group flat TIERS by size label, sorted ascending by qty within each group.
  var GROUPS = {};
  var SIZE_LABELS = [];
  RAW_TIERS.forEach(function(t){
    t.gifts = (t.gifts || []).filter(function(g){ return g.variantId; });
    if (!GROUPS[t.size]){ GROUPS[t.size] = []; SIZE_LABELS.push(t.size); }
    GROUPS[t.size].push(t);
  });
  SIZE_LABELS.forEach(function(label){
    GROUPS[label].sort(function(a,b){ return a.qty - b.qty; });
  });

  var currentSizeLabel = SIZE_LABELS[0];
  var currentThresholdIdx = 0;
  var currentStory = 0;
  var box = {};
  var selectedGift = null;   // chosen gift object {variantId, name, img, price}
  var visibleCount = 16;
  var PAGE_SIZE = 16;

  function currentTier(){ return GROUPS[currentSizeLabel] ? GROUPS[currentSizeLabel][currentThresholdIdx] : null; }
  function fmt(n){ return "₹" + Math.round(n).toLocaleString("en-IN"); }
  function currentProducts(){ return STORIES[currentStory] ? STORIES[currentStory].products : []; }
  function findProduct(id){
    for (var i=0;i<STORIES.length;i++){
      var found = STORIES[i].products.find(function(x){ return String(x.id) === String(id); });
      if (found) return found;
    }
    return null;
  }
  function boxTotalQty(){
    var t = 0;
    for (var k in box){ t += box[k]; }
    return t;
  }
  function tierHasGifts(t){ return t && t.gifts && t.gifts.length > 0; }
  function giftValidForTier(t){
    if (!selectedGift || !tierHasGifts(t)) return false;
    return t.gifts.some(function(g){ return String(g.variantId) === String(selectedGift.variantId); });
  }

  function renderTabs(){
    var el = document.getElementById("byob-sizeTabs");
    el.innerHTML = SIZE_LABELS.map(function(label){
      var base = GROUPS[label][0];
      var active = label === currentSizeLabel;
      var giftHtml = tierHasGifts(base) ? ' <span class="tab-gift"></span>' : '';
      return '<div class="size-card ' + (active ? "active" : "") + '" data-label="' + label + '">' +
        '<div class="sz">' + label + "</div>" +
        '<div class="deal">Any ' + base.qty + " · " + fmt(base.price) + giftHtml + "</div>" +
      "</div>";
    }).join("");
    el.querySelectorAll(".size-card").forEach(function(card){
      card.addEventListener("click", function(){
        currentSizeLabel = card.dataset.label;
        currentThresholdIdx = 0;
        box = {};
        selectedGift = null;
        renderAll();
      });
    });
  }

  function renderStories(){
    var el = document.getElementById("byob-storyRow");
    el.innerHTML = STORIES.map(function(s, i){
      var avatar = s.img || (s.products[0] ? s.products[0].img : "");
      var active = i === currentStory;
      return '<div class="story ' + (active?"active":"") + '" data-i="' + i + '">' +
        '<div class="story-circle">' +
          '<img src="' + avatar + '" alt="' + s.label + '">' +
          '<div class="story-tick"><svg width="10" height="10" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
        "</div>" +
        '<span class="story-label">' + s.label + "</span>" +
      "</div>";
    }).join("");
    el.querySelectorAll(".story").forEach(function(s){
      s.addEventListener("click", function(){
        currentStory = parseInt(s.dataset.i, 10);
        visibleCount = PAGE_SIZE;
        renderAll();
      });
    });
  }

  function renderChooseTitle(){
    var t = currentTier();
    if (!t) return;
    document.getElementById("byob-chooseTitle").textContent = "Choose your " + t.qty + " fragrances";
    document.getElementById("byob-chooseSub").textContent = t.size + " bottles · " + fmt(t.price) + " for the box";
  }

  function renderGiftPicker(){
    var t = currentTier();
    var picker = document.getElementById("byob-giftPicker");
    var list = document.getElementById("byob-giftList");
    if (!picker || !list) return;

    var isComplete = t && boxTotalQty() >= t.qty;
    if (!t || !tierHasGifts(t) || !isComplete){
      picker.style.display = "none";
      list.innerHTML = "";
      return;
    }

    picker.style.display = "block";
    list.innerHTML = t.gifts.map(function(g, i){
      var sel = selectedGift && String(selectedGift.variantId) === String(g.variantId);
      return '<div class="gift-row ' + (sel ? "selected" : "") + '" data-gi="' + i + '">' +
        '<div class="gift-thumb">' + (g.img ? '<img src="' + g.img + '" alt="' + g.name + '">' : "") + '</div>' +
        '<div class="gift-body">' +
          '<div class="gift-name">' + g.name + '</div>' +
        '<div class="gift-price-line"><span class="gift-price">' + fmt(g.price) + '</span></div>' +
        '</div>' +
        '<div class="gift-pick">' + (sel ? "✓" : "") + '</div>' +
      '</div>';
    }).join("");

    list.querySelectorAll(".gift-row").forEach(function(row){
      row.addEventListener("click", function(){
        var g = t.gifts[parseInt(row.dataset.gi, 10)];
        selectedGift = g;
        renderAll();
      });
    });
  }

  function renderSlots(){
    var t = currentTier();
    if (!t) return;
    var picked = [];
    for (var id in box){
      var p = findProduct(id);
      if (p){ for (var i=0;i<box[id];i++){ picked.push(p); } }
    }
    var filled = boxTotalQty();
    var isComplete = filled >= t.qty;
    var hasGifts = tierHasGifts(t);
    var giftChosen = giftValidForTier(t);
    var html = "";
    for (var s=0;s<t.qty;s++){
      if (picked[s]){
        var slotThumb = picked[s].img || picked[s].originalImg || picked[s].ogImg;
        html += '<div class="slot filled">' +
          (slotThumb ? '<img src="' + slotThumb + '" alt="' + picked[s].name + '">' : "") +
          '<div class="slot-remove" data-remove="' + picked[s].id + '">&times;</div>' +
        "</div>";
      } else {
        html += '<div class="slot"><div class="slot-num">' + (s+1) + "</div></div>";
      }
    }

    // Gift slot — shown when box complete and a gift is chosen
    if (isComplete && giftChosen) {
      html += '<div class="slot slot-gift filled" title="Combo item">' +
        (selectedGift.img ? '<img src="' + selectedGift.img + '" alt="Combo item">' : '<div class="slot-gift-ic">+</div>') +
      '</div>';
    } else if (isComplete && hasGifts) {
      html += '<div class="slot slot-gift" title="Pick your combo item"><div class="slot-gift-ic">+</div></div>';
    }

    document.getElementById("byob-slotRow").innerHTML = html;
    document.querySelectorAll("[data-remove]").forEach(function(btn){
      btn.addEventListener("click", function(){
        var pid = btn.dataset.remove;
        if (box[pid]){
          box[pid] -= 1;
          if (box[pid] <= 0) delete box[pid];
        }
        renderAll();
      });
    });

    var group = GROUPS[currentSizeLabel];
    var nextTier = group[currentThresholdIdx + 1];
    var prevTier = group[currentThresholdIdx - 1];
    var outer = document.getElementById("byob-slotOuter");
    outer.classList.toggle("complete", isComplete);

    var statusEl = document.getElementById("byob-slotStatus");
    var btn = document.getElementById("byob-checkoutBtn");
    var upsell = document.getElementById("byob-upsell");

    // Gift banner
    var giftBanner = document.getElementById("byob-giftBanner");
    if (giftBanner) {
      if (hasGifts) {
        if (isComplete && giftChosen) {
          giftBanner.innerHTML = '<strong>' + selectedGift.name + '</strong> added to your combo!';
          giftBanner.style.display = "block";
          giftBanner.className = "byob-gift-banner active";
          giftBanner.id = "byob-giftBanner";
        } else if (isComplete) {
          giftBanner.innerHTML = 'Box complete — <strong>pick your combo item below</strong>';
          giftBanner.style.display = "block";
          giftBanner.className = "byob-gift-banner";
          giftBanner.id = "byob-giftBanner";
        } else {
          giftBanner.innerHTML = 'Complete your box, then <strong>pick 1 combo item</strong>';
          giftBanner.style.display = "block";
          giftBanner.className = "byob-gift-banner";
          giftBanner.id = "byob-giftBanner";
        }
      } else {
        giftBanner.style.display = "none";
      }
    }

    if (isComplete){
      statusEl.textContent = "Box complete — saved " + fmt(t.mrp - t.price);
      if (hasGifts && !giftChosen){
        btn.disabled = false;
        btn.textContent = "Pick your combo item";
      } else {
        btn.disabled = false;
        btn.textContent = "Checkout — " + fmt(t.price);
      }
      if (nextTier){
        upsell.style.display = "flex";
        document.getElementById("byob-upsellText").textContent =
          "Add " + (nextTier.qty - t.qty) + " more for just " + fmt(nextTier.price - t.price) + " extra";
        document.getElementById("byob-upsellBtn").textContent =
          "Upgrade to " + nextTier.qty + " · " + fmt(nextTier.price);
      } else {
        upsell.style.display = "none";
      }
    } else {
      statusEl.textContent = filled + " of " + t.qty + " picked";
      btn.disabled = true;
      btn.textContent = "Add " + (t.qty - filled) + " more";
      upsell.style.display = "none";
    }

    var downgrade = document.getElementById("byob-downgrade");
    if (prevTier){
      downgrade.style.display = "inline-block";
      downgrade.textContent = "Undo";
    } else {
      downgrade.style.display = "none";
    }
  }

  // Gender glyph, keyed off the genderClass Liquid already computed (male/female/unisex).
  function genderGlyph(genderClass){
    if (genderClass === "male") return "♂";
    if (genderClass === "female") return "♀";
    if (genderClass === "unisex") return "⛎";
    return "";
  }

  // Real "units sold" metafield when present, otherwise a stable pseudo-random fallback.
  function boughtCount(p){
    if (p.unitsSold && Number(p.unitsSold) > 0) return Number(p.unitsSold);
    var n = parseInt(String(p.id).slice(-3), 10) || 0;
    if (n % 5 !== 0) return 0;
    return 3 + (n % 14);
  }

  function renderList(){
    var t = currentTier();
    if (!t) return;
    var allProducts = currentProducts();
    var products = allProducts.slice(0, visibleCount);
    var filled = boxTotalQty();
    var full = filled >= t.qty;
    var el = document.getElementById("byob-list");
    document.getElementById("byob-resultCount").textContent = allProducts.length + " fragrances";

    el.innerHTML = products.map(function(p, idx){
      var qty = box[p.id] || 0;
      var bought = boughtCount(p);

      var rotateItems = [];
      if (p.longevity) rotateItems.push("Long Lasting · " + p.longevity);
      if (p.occasion) rotateItems.push(p.occasion.split(",")[0].trim());
      var rotatorHtml = rotateItems.length
        ? '<div class="row-rotator" data-items="' + encodeURIComponent(JSON.stringify(rotateItems)) + '" data-idx="0">' + rotateItems[0] + "</div>"
        : "";

      var genderHtml = p.gender
        ? '<span class="row-gender ' + p.genderClass + '">' + genderGlyph(p.genderClass) + " " + p.gender + "</span>"
        : "";
      var starHtml = p.isStar ? '<span class="row-star">★</span>' : "";
      var dotHtml = p.hasVariant ? '<span class="row-dot ' + p.dotVariant + '"></span>' : "";
      var metaHtml = '<div class="row-meta-line">' + (genderHtml || starHtml || dotHtml ? genderHtml + starHtml + dotHtml : "&nbsp;") + "</div>";

      var summaryParts = [];
      if (p.longevity) summaryParts.push(p.longevity);
      if (p.occasion) summaryParts.push(p.occasion.split(",")[0].trim());
      var summaryHtml = '<div class="row-summary">' + (summaryParts.length ? summaryParts.join(", ") : "&nbsp;") + "</div>";

      return '<div class="row ' + (qty>0?"in-box":"") + '">' +
        '<div class="row-num">' + (idx+1) + "</div>" +
        '<div class="row-og-thumb">' + (p.originalImg ? '<img src="' + p.originalImg + '" alt="' + p.name + '">' : "") + "</div>" +
        '<div class="row-thumb">' + (p.img ? '<img src="' + p.img + '" alt="' + p.name + '">' : "") + "</div>" +
        '<div class="row-body">' +
          '<div class="row-title-line"><span class="row-name">' + p.name + "</span></div>" +
          metaHtml +
          summaryHtml +
        "</div>" +
        '<div class="row-side">' +
        (qty > 0
          ? '<div class="stepper">' +
              '<button data-act="minus" data-id="' + p.id + '">-</button>' +
              '<span class="qty">' + qty + "</span>" +
              '<button data-act="plus" data-id="' + p.id + '" ' + (full?"disabled":"") + ">+</button>" +
            "</div>"
          : '<button class="add-btn" data-act="plus" data-id="' + p.id + '" ' + (full?"disabled":"") + ">+</button>"
        ) +
        "</div>" +
      "</div>";
    }).join("") +
    '<div class="scroll-sentinel" id="byob-sentinel"></div>' +
    (visibleCount < allProducts.length
      ? '<div class="loading-row" id="byob-loadingRow" style="display:none;"><div class="spinner"></div>Loading more fragrances</div>'
      : (allProducts.length > PAGE_SIZE ? '<div class="loading-row">You\'ve seen all ' + allProducts.length + ' fragrances</div>' : ''));

    el.querySelectorAll("[data-act]").forEach(function(btn){
      if (btn.disabled) return;
      btn.addEventListener("click", function(){
        var id = btn.dataset.id;
        if (btn.dataset.act === "plus"){
          if (boxTotalQty() >= t.qty) return;
          box[id] = (box[id] || 0) + 1;
        } else {
          box[id] = Math.max(0, (box[id] || 0) - 1);
          if (box[id] === 0) delete box[id];
        }
        renderAll();
      });
    });

    setupScrollObserver();
    setupRotators();
  }

  var rotatorInterval = null;

  function setupRotators(){
    if (rotatorInterval) clearInterval(rotatorInterval);
    rotatorInterval = setInterval(function(){
      document.querySelectorAll(".row-rotator").forEach(function(el){
        var items;
        try { items = JSON.parse(decodeURIComponent(el.dataset.items || "%5B%5D")); } catch(e){ items = []; }
        if (items.length < 2) return;
        el.classList.add("fade");
        setTimeout(function(){
          var idx = (parseInt(el.dataset.idx, 10) + 1) % items.length;
          el.dataset.idx = idx;
          el.textContent = items[idx];
          el.classList.remove("fade");
        }, 300);
      });
    }, 2200);
  }

  var scrollObserver = null;
  var isLoadingMore = false;

  function setupScrollObserver(){
    if (scrollObserver) scrollObserver.disconnect();
    var sentinel = document.getElementById("byob-sentinel");
    if (!sentinel) return;
    var allProducts = currentProducts();
    scrollObserver = new IntersectionObserver(function(entries){
      if (entries[0].isIntersecting && !isLoadingMore && visibleCount < allProducts.length){
        isLoadingMore = true;
        var loadingRow = document.getElementById("byob-loadingRow");
        if (loadingRow) loadingRow.style.display = "flex";
        setTimeout(function(){
          visibleCount = Math.min(allProducts.length, visibleCount + PAGE_SIZE);
          isLoadingMore = false;
          renderList();
        }, 400);
      }
    }, { rootMargin: "300px" });
    scrollObserver.observe(sentinel);
  }

  function renderAll(){
    var t = currentTier();
    // drop gift choice if it no longer belongs to the current tier's options
    if (selectedGift && !giftValidForTier(t)) selectedGift = null;
    renderTabs();
    renderStories();
    renderChooseTitle();
    renderSlots();
    renderGiftPicker();
    renderList();
  }

  function showToast(msg){
    var toast = document.getElementById("byob-toast");
    toast.textContent = msg;
    toast.classList.add("show");
    setTimeout(function(){ toast.classList.remove("show"); }, 2200);
  }

  document.getElementById("byob-upsellBtn").addEventListener("click", function(){
    currentThresholdIdx += 1;
    renderAll();
  });

  document.getElementById("byob-downgrade").addEventListener("click", function(){
    var group = GROUPS[currentSizeLabel];
    var prevTier = group[currentThresholdIdx - 1];
    if (!prevTier) return;
    currentThresholdIdx -= 1;
    var overflow = boxTotalQty() - prevTier.qty;
    if (overflow > 0){
      var ids = Object.keys(box);
      var i = ids.length - 1;
      while (overflow > 0 && i >= 0){
        var id = ids[i];
        var take = Math.min(box[id], overflow);
        box[id] -= take;
        overflow -= take;
        if (box[id] <= 0) delete box[id];
        i--;
      }
    }
    renderAll();
  });

  document.getElementById("byob-checkoutBtn").addEventListener("click", function(){
    var t = currentTier();
    if (boxTotalQty() < t.qty || !t.variantId) return;

    // Gift tiers require the customer to pick their gift first
    if (tierHasGifts(t) && !giftValidForTier(t)){
      showToast("Pick your combo item first");
      var picker = document.getElementById("byob-giftPicker");
      if (picker) picker.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    var names = [];
    for (var id in box){
      var p = findProduct(id);
      if (p) names.push(p.name + " x" + box[id]);
    }

    var giftChosen = giftValidForTier(t);

    // Cart NOTE gets dropped by GoKwik's order creation, but cart
    // ATTRIBUTES survive — box contents written as attributes.
    var attributes = {
      "Box size": t.size,
      "Box contents": names.join(", "),
      "gift": giftChosen ? selectedGift.name : ""
    };

    var code = t.discountCode ? t.discountCode.trim() : "";

    // Final stop: the theme's native cart-open URL — no reload of this
    // heavy builder page, the home page opens the slide cart itself.
    var target = "/?openCart=true";
    if (code){
      // Discount hop first-from-the-end: sets the cookie (replacing any
      // stale code), then lands on the cart-open URL.
      target = "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(target);
    }

    // Hop 2 (optional): add the chosen combo chain via plain navigation.
    if (giftChosen){
      var q2 = "id=" + selectedGift.variantId + "&quantity=1" +
        "&properties%5B_gift%5D=true" +
        "&properties%5B_gift_for%5D=" + encodeURIComponent(t.size + " box") +
        "&return_to=" + encodeURIComponent(target);
      target = "/cart/add?" + q2;
    }

    // Hop 1: add the box product via plain navigation.
    var q1 = "id=" + t.variantId + "&quantity=1" +
      "&properties%5BSize%5D=" + encodeURIComponent(t.size) +
      "&properties%5BBox%20contents%5D=" + encodeURIComponent(names.join(", ")) +
      "&return_to=" + encodeURIComponent(target);

    showToast("Adding your box\u2026");

    // Write the attributes BEFORE the chain (an attributes-only update
    // never auto-opens the slide cart), then start the navigation.
    var go = function(){ window.location.href = "/cart/add?" + q1; };
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: attributes })
    }).then(go).catch(go);
  });

  renderAll();
})();
